"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _theme = require("../theme");
require("./content-crate.css");
var _sharedVariables = require("../../shared-variables");
var _excluded = ["className", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * `ContentCrate` is a panel that contains primary page content. It is designed to be used in
 * conjunction with `HeaderCrate`.
 */
var ContentCrate = function ContentCrate(_ref) {
  var className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    var isDarkTheme = theme === _theme.themes.dark;
    var themeClass = isDarkTheme ? 'color-textWhite' : '';
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: "sb-contentCrate ".concat(className || '', " ").concat(themeClass)
    }, otherProps), /*#__PURE__*/_react["default"].createElement("style", {
      // Make sure the background color extends to full height of content
      // when using flex-column layoouts
      dangerouslySetInnerHTML: {
        __html: "body { background-color: ".concat(isDarkTheme ? _sharedVariables.variables.colorHouseGreen : _sharedVariables.variables.colorNeutralCool, " }")
      }
    }), children);
  });
};
ContentCrate.displayName = 'ContentCrate';
ContentCrate.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string
} : {};
var _default = exports["default"] = ContentCrate;